import SearchBar from 'features/searchBar';

const RIGHT_RAIL_SEARCH_SELECTOR = '[data-right-rail-search]';

/**
 * openSearchResult: Opens a new browser tab with the search result's location URL.
 * @param {Object} result - The search result object containing the location URL.
 */
function openSearchResult(result) {
  const locationUrl = (result?.locationUrl || '').trim();

  if (!locationUrl) {
    return;
  }

  window.open(locationUrl, '_blank');
}

/**
 * trackSelection: Dispatches a custom event to indicate that the user has selected
 * a search result from the right rail search bar.
 * @param {string} selectedText - The text of the selected search result.
 */
function trackSelection(selectedText) {
  document.body.dispatchEvent(
    new CustomEvent('right_rail_search_selected', {
      detail: {
        selectedValue: selectedText,
      },
    })
  );
}

/**
 * createSearchBar: Initializes the search bar component for the right-rail search area.
 * It looks for the right-rail search container and sets up the search bar with
 * the necessary configuration.
 * @returns {SearchBar|null} - Returns the initialized SearchBar instance or
 * null if the right rail search container is not found.
 */
function createSearchBar() {
  const rightRailRoot = document.querySelector(RIGHT_RAIL_SEARCH_SELECTOR);
  if (!rightRailRoot) {
    return null;
  }

  const searchContainers = rightRailRoot.querySelectorAll('[data-search-bar-container]');
  if (!searchContainers?.length) {
    return null;
  }

  return new SearchBar({
    searchContainers,
    smallScreenSearchContainer: rightRailRoot.querySelector('[data-search-bar-container-mobile]'),
    searchBarModalOpen: document.querySelector('[data-open-search-bar-modal]'),
    searchBarModal: rightRailRoot.querySelector('[data-search-bar-modal]'),
    header: document.querySelector('[data-main-header]'),
    savedSearchContainer: null,
    locationType: '',
    initialSearchText: ''
  });
}

/**
 * initRightRailSearchBar: Initializes the right rail search bar for the News & Trends page.
 * It sets up the search bar and subscribes to the selected result observable to handle
 * search result selections.
 */
function initRightRailSearchBar() {
  const searchBar = createSearchBar();
  if (!searchBar) {
    return;
  }

  searchBar
    .getSelectedResultObservable()
    .subscribe((result) => {
      if (!result) {
        return;
      }

      trackSelection(result.selectedText);
      openSearchResult(result);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRightRailSearchBar);
} else {
  initRightRailSearchBar();
}
